import { bankSettingsApi } from "../../../api/apiClient";

/************************ BANK SETTINGS****************/
function getCurrencies(data) {
  return bankSettingsApi.get("/shared/currencies", data);
}

function getConfiguration() {
  return bankSettingsApi.get(`/bank/config`);
}

function createConfiguration(data) {
  return bankSettingsApi.post("/bank/config", data);
}

function updateConfiguration(data) {
  return bankSettingsApi.put(`/bank/config`, data);
}

function toggleUat() {
  return bankSettingsApi.put(`/bank/config/toggle-uat`);
}

function sendTestEmail(data) {
  return bankSettingsApi.post(`/bank/config/test-email`, data);
}

export const bankSettingsServices = {
  getCurrencies,
  getConfiguration,
  createConfiguration,
  updateConfiguration,
  toggleUat,
  sendTestEmail,
};
